import { Grid } from "@mui/material";
import { StateHandle } from "StateHandle";
import { P } from "theme/typography";
import { FormFieldCellEditor } from "./FormFieldCellEditor";
import { CaseInfo, Cell } from "generated/graphql";
import { cellValueFromGQL, FieldCellValueUI, gqlCellValueFromValue } from "Backend";
import produce from "immer";

interface ValueGroupProps {
  caseInfo?: CaseInfo;
  cells: Cell[];
  stateHandle: StateHandle<FieldCellValueUI[]>;
  disabled?: boolean;
  compact?: boolean;
  // Force select cells to show empty options regardless of cell config
  displayEmptyOption?: boolean;
}

export const ValueGroup = (props: ValueGroupProps) => {
  const { caseInfo, cells, stateHandle, disabled, compact, displayEmptyOption } = props;
  const [state, setState] = stateHandle;

  if (state.length < cells.length) {
    return <P>Loading</P>;
  }
  return (
    <Grid container spacing={2} sx={{ overflow: "auto" }}>
      {cells.map((cell, cellIndex) => {
        return (
          <Grid item key={cell.id} sm={compact ? 8 : 6} md={compact ? 6 : 4} lg={compact ? 6 : 3}>
            <FormFieldCellEditor
              label={cell.name}
              caseInfo={caseInfo}
              cell={cell}
              tabular={false}
              disabled={disabled}
              displayEmptyOption={displayEmptyOption}
              error={state[cellIndex]?.error}
              setError={(err) => {
                setState(
                  produce((draft) => {
                    const c = draft[cellIndex];

                    if (c !== undefined) {
                      c.error = err;
                    }
                  })
                );
              }}
              value={cellValueFromGQL(state[cellIndex]?.value)}
              setValue={(v) => {
                setState(
                  produce((draft) => {
                    const c = draft[cellIndex];

                    if (c !== undefined) {
                      c.value = gqlCellValueFromValue(cell.type, v);
                    }
                  })
                );
              }}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};
